import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { VestingTypeEnum } from 'constants/vesting'
import { VestingProviderV2 } from 'context/vesting-context-provider-v2'
import Content from 'modules/vesting-v2/content'
import Header from 'modules/vesting-v2/header'

const VestingVentureV2 = () => {
  return (
    <VestingProviderV2 type={VestingTypeEnum.VESTING_VENTURE_V2}>
      <div className="main-section user">
        <Breadcrumb additionalItems={[BREADCRUMBS.VESTING]} />
        <Header />
        <Content />
      </div>
    </VestingProviderV2>
  )
}

export default VestingVentureV2
